module.exports = __webpack_public_path__ + "static/media/17.b4104dbb.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/hats/17.png
// module id = 1299
// module chunks = 0